module.exports = __webpack_public_path__ + "img/safety.8d4ff9d4.png";